var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpvoteFilled = function SvgUpvoteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 108 108"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#upvote_filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.29 50.938H9.607a3.17 3.17 0 0 0-3.17 3.17v50.724a3.17 3.17 0 0 0 3.17 3.171h12.681c1.75 0 3.17-1.42 3.17-3.171V54.108a3.17 3.17 0 0 0-3.17-3.17M101.496 59.326c-.559-4.919-5.153-8.404-10.103-8.404H66.676c2.1-3.761 3.228-14.4 3.178-18.745-.082-7.194-6.04-12.958-13.233-12.958h-2.616a3.17 3.17 0 0 0-3.17 3.17c0 7.331-2.855 20.564-8.239 25.948-3.624 3.623-6.721 4.936-10.783 6.966v47.571c6.219 2.073 14.115 5.113 26.15 5.113h20.739c6.833 0 12.155-6.329 9.507-13.015 4.034-1.1 7.01-4.8 7.01-9.177a9.5 9.5 0 0 0-.67-3.505c6.799-1.852 9.301-10.246 4.583-15.517a9.5 9.5 0 0 0 2.364-7.447"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upvote_filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h108v108H0z"
  })))));
};
export default SvgUpvoteFilled;